import { define } from 'wicked-elements'

define('[data-component~="menu-simple"]', {
  init () {
    this.open = false
    this.$button = this.element.querySelector('button')
    this.$nav = this.element.querySelector('nav')
  },
  connected () {
    this.$button.onclick = () => {
      this.open = !this.open
      if (this.open) {
        this.element.classList.remove('is-closed')
        this.$nav.classList.replace('hidden', 'flex')
        this.$button.classList.replace('menu--open', 'menu--close')
      } else {
        this.element.classList.add('is-closed')
        this.$nav.classList.replace('flex', 'hidden')
        this.$button.classList.replace('menu--close', 'menu--open')
      }
    }
  }
})